export default "__VITE_ASSET__DE3eW7Qj__"